import React from 'react';

import Link from 'depop/components/Link';

import { FormattedMessage } from 'react-intl';

const SpacesLink = props =>
  <Link to={{ pathname: '/about/spaces' }} {...props}>
    <FormattedMessage
      id="app.spacesLabel"
      description="Spaces Label"
      defaultMessage="Spaces"
    />
  </Link>;

export default SpacesLink;



// WEBPACK FOOTER //
// ../src/client/components/layout/navigation/links/SpacesLink.js